module.exports = __webpack_public_path__ + "media/images/stars/0-59cc2a3a0c8ca22f70fc4391fdb6eba9.png";